export default "__VITE_ASSET__4f3705ac__"